<template #id>
    <div style="width: 100%; height: 100%; min-width: 1280px; padding: 10px;">
      <div style="display: flex; flex-direction: column; flex: 1; height: 100%; min-width: 1280px;">
        <ejs-grid ref="grid" height="100%" width="100%" :toolbar="toolbar" :toolbarClick="toolbarClick" :selectionSettings="selectionOptions" :allowTextWrap="true" :textWrapSettings="wrapSettings" :dataBound="dataBound" :dataSource="data" :allowPaging="true" :pageSettings="pageSettings" :allowFiltering="true" :filterSettings="filterOptions" :allowSorting="true" :allowMultiSorting='true' :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true">
          <e-columns>
					  <e-column field="updateDate" :headerText="$t('UpdateDate')" textAlign="Left" :customAttributes="customAttributes" width="170" type="datetime" :format="dateTimeFormatOptions"></e-column>
					  <e-column field="autoTaraTimer" :headerText="$t('AutoTaraTimer')" textAlign="Left" :customAttributes="customAttributes" width="170" :template="autoTaraTimerTemplate"></e-column>
					  <e-column field="autoTaraWeight" :headerText="$t('AutoTaraWeight')" textAlign="Left" :customAttributes="customAttributes" width="170" :template="autoTaraWeightTemplate"></e-column>
					  <e-column field="animalWeightCalibration" :headerText="$t('AnimalWeightCalibration')" textAlign="Left" :customAttributes="customAttributes" width="230" :template="animalWeightCalibrationTemplate"></e-column>
					  <e-column field="errorGate" :headerText="$t('ErrorGate')" textAlign="Left" :customAttributes="customAttributes" width="130"></e-column>
					  <e-column field="noDecisionTime" :headerText="$t('NoDecisionTime')" textAlign="Left" :customAttributes="customAttributes" width="170" :template="noDecisionTimeTemplate"></e-column>
					  <e-column field="sprayTime" :headerText="$t('SprayTime')" textAlign="Left" :customAttributes="customAttributes" width="130" :template="sprayTimeTemplate"></e-column>
					  <e-column field="minWeightOnPlatform" :headerText="$t('MinWeightOnPlatform')" textAlign="Left" :customAttributes="customAttributes" width="210" :template="minWeightOnPlatformTemplate"></e-column>
					  <e-column field="weightTime" :headerText="$t('WeightTime')" textAlign="Left" :customAttributes="customAttributes" width="140" :template="weightTimeTemplate"></e-column>
					  <e-column field="sortingMode" :headerText="$t('SortingMode')" textAlign="Left" :customAttributes="customAttributes" width="160"></e-column>
					  <e-column field="wagonAutoCloseTime" :headerText="$t('SortByWeightRanges')" textAlign="Left" :customAttributes="customAttributes" :template="sortByWeightRangeTemplate" width="230"></e-column>
          </e-columns>
        </ejs-grid>
		  </div>
    </div>
</template>

<script>
import { getSortingSettingsHistory } from '@api'
import { Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';
import Vue from 'vue'

export default {
    props: ['systemId', 'systemName'],
    provide: {
        grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport ]
    },
    data() {
        return {
			    data: [],
          pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
          toolbar: [
                    { text: this.$t('SettingsSorting'), id: 'table-settings-title' },
                    { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right',},
                    { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export'},
                    { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export'},
                    { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export'},

            'Search',
          ],
          wrapSettings: { wrapMode: "Content" },
          selectionOptions: { type: "Multiple" },
          filterOptions: {
            type: "Menu",
          },
          customAttributes : {class: 'customcss'},
          sortingModes: [],
          sortByWeightRangeTemplate: function() {
                return {
                    template: Vue.component('sortByWeightRangeTemplate', {
                        template: `
                            <div>
                              <p class="mb-0">{{ range1 }}</p>
                              <p class="mb-0">{{ range2 }}</p>
                              <p class="mb-0">{{ range3 }}</p>
                            </div>
                        `,
                        data: function(){
                            return {
                                data: {}
                            }
                        },
                        computed: {
                            range1() {
                              return this.$t("From") + " 0kg " + this.$t("to") + " " + this.data.sortingByWeightValue1 + " " + this.$t("goToGate") + " " + this.data.sortByWeightGate1 + ".";
                            },
                            range2() {
                              return this.$t("From") + " " + this.data.sortingByWeightValue1 + "kg " + this.$t("to") + " " + this.data.sortingByWeightValue2 + " " + this.$t("goToGate") + " " + this.data.sortByWeightGate2 + ".";
                            },
                            range3() {
                              return this.$t("Over") + " " + this.data.sortingByWeightValue2 + "kg " + this.$t("goToGate") + " " + this.data.sortByWeightGate3 + ".";
                            }
                        },
                        mounted() {
                        }
                    })
                }
          },
          autoTaraWeightTemplate: function() {
              return {
                  template: Vue.component('autoTaraWeightTemplate', {
                      template: `
                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">
                            {{data.autoTaraWeight}}kg
                          </div>
                          <div v-else>
                            {{data.autoTaraWeight}}lb
                          </div>
                      `
                  })
              }
          },
          animalWeightCalibrationTemplate: function() {
              return {
                  template: Vue.component('animalWeightCalibrationTemplate', {
                      template: `
                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">
                            {{data.animalWeightCalibration}}kg
                          </div>
                          <div v-else>
                            {{data.animalWeightCalibration}}lb
                          </div>
                      `
                  })
              }
          },
          minWeightOnPlatformTemplate: function() {
              return {
                  template: Vue.component('minWeightOnPlatformTemplate', {
                      template: `
                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">
                            {{data.minWeightOnPlatform}}kg
                          </div>
                          <div v-else>
                            {{data.minWeightOnPlatform}}lb
                          </div>
                      `
                  })
              }
          },
          autoTaraTimerTemplate: function() {
              return {
                  template: Vue.component('autoTaraTimerTemplate', {
                      template: `
                          <div>
                            {{data.autoTaraTimer}}s
                          </div>
                      `
                  })
              }
          },
          noDecisionTimeTemplate: function() {
              return {
                  template: Vue.component('noDecisionTimeTemplate', {
                      template: `
                          <div>
                            {{data.noDecisionTime}}s
                          </div>
                      `
                  })
              }
          },
          weightTimeTemplate: function() {
              return {
                  template: Vue.component('weightTimeTemplate', {
                      template: `
                          <div>
                            {{data.weightTime}}s
                          </div>
                      `
                  })
              }
          },
          sprayTimeTemplate: function() {
              return {
                  template: Vue.component('sprayTimeTemplate', {
                      template: `
                          <div>
                            {{data.sprayTime}}ms
                          </div>
                      `
                  })
              }
          },
          dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type:'dateTime'},
        }
    },
    methods: {
      async getData() {
          this.sortingModes.push({
          Name: this.$t("OnlySortByAnimalSettings"),
          Value: 85,
        });
        this.sortingModes.push({
          Name: this.$t("WeightAndSortByAnimalSettings"),
          Value: 0,
        });
        this.sortingModes.push({
          Name: this.$t("WeightAndSortByWeightRange"),
          Value: 170,
        });

        this.data = [];
        this.$emit('spin', true)

        var sortingSettingsHistory = await getSortingSettingsHistory(this.systemId);
        sortingSettingsHistory.forEach(item => item.sortingMode = this.sortingModes.find(
          (m) => m.Value == item.weightTurnedOn).Name)
        this.data = sortingSettingsHistory;

        this.$emit('spin', false)
      },
      toolbarClick: function(args) {
            switch(args.item.id){
                case "table-system-title":
                  this.$router.push({
                    name: "systems"
                  })
                  break;
                case "table-settings-title":
                  this.getData();
                  break;
                case "pdf-export":
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.$refs.grid.excelExport();
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
            }
        },
      dataBound: function () {
        this.$refs.grid.autoFitColumns();
      },
    },
    mounted: async function() {
        await this.getData();
    },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/System/SettingsSorting.vue